import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentLocation: getLocation(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

const CustomSignInRequiredToBrowse: React.FC<Props> = ({
    id,
    userName,
    currentUserIsGuest,
    isSignInPage,
    signInUrl,
    currentLocation,
    history,
}) => {
    React.useEffect(() => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/buy-from-kgpco");
            } else {
                const returnUrl = currentLocation.pathname + currentLocation.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    window.location.href = `${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`;
                }
            }
        }
    }, [currentLocation]);
    if (!userName || currentUserIsGuest) {
        return null;
    }
    return (
        <StyledWrapper>
            <Zone contentId={id} zoneName="AuthContentContainer" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(CustomSignInRequiredToBrowse)),
    definition: {
        group: "Common",
        displayName: "Custom Sign In Required To Browse Container",
    },
};

export default widgetModule;
